
const DROPDOWN_SELECTOR = "[data-dropdown-filter]"
const DROPDOWN_SELECT_CONTAINER_SELECTOR = "[data-dropdown-select]"
const DROPDOWN_SELECT_SELECTOR = "[data-dropdown-select-value]"
const DROPDOWN_OPTIONS_CONTAINER_SELECTOR = "[data-dropdown-options]"
const DROPDOWN_OPTIONS_SELECTOR = "[data-dropdown-option]"
const dropdowns = document.querySelectorAll(DROPDOWN_SELECTOR)

function init(){
  
  if(dropdowns.length === 0) return
  
  initDropdowns(dropdowns)
  
}

function initDropdowns(dropdowns) {
  
  dropdowns.forEach(dropdown => {

    const dropdownOptionsContaner = dropdown.querySelector(DROPDOWN_OPTIONS_CONTAINER_SELECTOR)
    const dropdownOptions = dropdown.querySelectorAll(DROPDOWN_OPTIONS_SELECTOR)
    const dropdownSelect = dropdown.querySelector(DROPDOWN_SELECT_CONTAINER_SELECTOR)

    initSelect(dropdown, dropdownOptions, dropdownSelect, dropdownOptionsContaner)
    initOptions(dropdown, dropdownOptions)

    dropdown.addEventListener('click', (e) => {
      toggleDropdown(dropdownSelect)
    })
  
  });

}

function initSelect(dropdown, dropdownOptions, dropdownSelect, dropdownOptionsContaner){

  const dropdownSelectContent = dropdownSelect.querySelector(DROPDOWN_SELECT_SELECTOR)

  // Set innerHTml first the we get the real height of element after
  dropdownSelectContent.innerHTML = dropdownOptions[0].innerHTML;

  const containerHeight = dropdownSelect.offsetHeight
  dropdownOptionsContaner.style.top = `${containerHeight-2}px`

}

function toggleDropdown(dropdownSelect) {
  let isOpen = (dropdownSelect.getAttribute('aria-expanded', "true") === "true")

  if(isOpen){
    dropdownSelect.setAttribute('aria-expanded', 'false')
  }else{
    dropdownSelect.setAttribute('aria-expanded', 'true')
  }
}

function initOptions(dropdownSelect, dropdownOptions) {
  dropdownOptions.forEach(option => {
    option.addEventListener('click', () => {
      const textContainer = dropdownSelect.querySelector(DROPDOWN_SELECT_SELECTOR)
      textContainer.innerHTML = option.innerHTML
    })
  });
}



export default { init }